module.exports = __webpack_public_path__ + "static/media/ic_info.0fe52813.svg";